import '../../themeDefaults';

export default ({ datepickerReact, typography }) => ({
  wrapper: {
    borderRadius: 2,
    boxSizing: 'border-box',
    display: 'inline-block',
    height: 28,
    marginRight: 1,
    position: 'relative',
    ...datepickerReact.timepickerWrapper,
    '& select': {
      '&::-moz-focus-inner': {
        border: 0
      },
      '&::-ms-expand': {
        display: 'none'
      },
      '-moz-appearance': 'none',
      '-webkit-appearance': 'none',
      appearance: 'none',
      background: 'transparent',
      border: 0,
      borderRadius: 0,
      boxSizing: 'border-box',
      fontFamily: typography.fontFamily,
      fontSize: 14,
      height: '100%',
      lineHeight: '28px',
      option: {
        fontWeight: 'normal'
      },
      padding: [0, 5],
      position: 'relative',
      width: '100%',
      zIndex: 1
    }
  }
});
